import InvoiceLine from "emun.invoice/inv/inv-line.model";
import ServiceBus from "servicestack/service-bus";
import keyBy from "lodash/keyBy";

export default class Invoice {
  constructor(dto = {}, getProducts = false) {
    Object.assign(this, dto);
    this.lines = dto.lines.map(l => new InvoiceLine(l));
    if (getProducts) {
      const map = keyBy(dto.lines, "productId"); //groupBy
      ServiceBus.read(
        `QueryProducts.json?RetailerId=${dto.retailerId}&InvoiceId=${dto.id}`
      ).then(({ data }) => {
        const productMap = keyBy(data.results, "id"); //groupBy
        for (const l of this.lines) {
          Object.assign(l.product || {}, productMap[l.productId] || {});
        }
      });
      // ServiceBus.read(
      //   `QueryProducts.json?RetailerId=${dto.retailerId}&IdIn=${Object.keys(
      //     map
      //   ).join(",") || "NONE"}`
      // ).then(({ data }) => {
      //   const productMap = keyBy(data.results, "id"); //groupBy
      //   for (const l of this.lines) {
      //     Object.assign(l.product || {}, productMap[l.productId] || {});
      //   }
      // });
    }
  }
}
